import React from 'react';
/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  useCfmz,
  useMsgz,
  useLdrz,
  a,
  ls,
  f,
  gs,
//  BarC,
  BoxC,
  BtnC,
  IptC,
  LblC,
  MsgC,
  SrlC,
  GridC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";
import { useMsgz } from "./_csMdlMsg";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as icm from './icm';
import * as ihd from './ihd';

import * as icvi18 from './icvI18___Mz';

import * as icvi1z from './icvI1z___Mz';

import * as icvI1zS11Co2a from './icvI1zS11Co2a';
import * as icvI1zS11Co2b from './icvI1zS11Co2b';
import * as icvI1z___TzCnt from './icvI1z___TzCnt';

let $i1zz = icvi1z.ilzI1zz();

let $i18rs = [] as _ht.ls;

let $i18rz = {} as _ht.dz;
let $i15rz = {} as _ht.dz;

export const N = (pz: {
  sPz: _ht.dz,
  pagez: _ht.dz,
/*
  cz: {
    i18r_fst: _ht.n,
  }
*/
}) => {

  const _frcUdt = ls.udtThis();
  const _gUserz = gs.useUserz();
  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();
  const _sCfmz = useCfmz();
  const _gStgz = gs.useStgz();

  const _loadI18rDzAsync = async (
    i18r_fst: _ht.n
  ) => {
    if (i18r_fst > 0) {
      await icm.setStgzAsync({
        _31r_fst: _gUserz.crt._31rz._fst,
        i18r_fst: i18r_fst
      });
      await icvi18.loadI18rDzAsync({
        i18r_fst: i18r_fst,
      })
      .then((_i18z: _ht.dz) => {
        $i18rz = _i18z.i18rz;
        $i15rz = _i18z.i15rz;
      });
    }
    else {
      await icm.setStgzAsync({
        _31r_fst: _gUserz.crt._31rz._fst,
      }); // 設定の初期化
      $i18rz = {};
      $i15rz = {};
    }
  };

  React.useEffect(() => {
//hf.l(`icvI1zS11Co2 84: here`);
    cmFTH.loadAllAsync({
      frcUdt: _frcUdt,
      ldrz: _sLdrz,
      bfrAsync: () => [
        icvi18.loadI18rLsAsync()
        .then( ( _ls: _ht.ls ) => { 
          $i18rs = _ls;
        }),
      ],
      atrAsync: () => [
        icvi1z.loadI1zrDzAsync({
          i1zr_fst: pz.sPz.crt.i1zr_fst,
        })
        .then( async ( _dz: _ht.dz ) => {
//_hm.l(`icvI1zS11Co2 119: ${pz.sPz.crt.i1zr_fst}, ${_hm.s(_dz)}`);
//hf.l(`icvI1zS11Co2 99: ${_dz.i1zrz?.i1zri18r1f}`);
          _hm.udtDz($i1zz, _dz);
          if (_dz.i1zrz?.i1zri18r1f > 0) { // 団体が指定されている場合
//hf.l(`icvI1zS11Co2 102: here`);
            await _loadI18rDzAsync(_dz.i1zrz?.i1zri18r1f);
          }
          else { // 団体が指定されていない場合
//hf.l(`icvI1zS11Co2 106: ${pz.cz.i18r_fst}`);
//hf.l(`icvI1zS11Co2 106: ${pz.sPz.crt.i18r_fst}`);
            _hm.udtDz($i1zz.i1zrz, {
//              i1zri18r1f: pz.cz.i18r_fst
              i1zri18r1f: pz.sPz.crt.i18r_fst
            });
//            await _loadI18rDzAsync(pz.cz.i18r_fst);
            await _loadI18rDzAsync(pz.sPz.crt.i18r_fst);
//            if (pz.cz.i18r_fst > 0) { // 前回の団体が指定されている場合
            if (pz.sPz.crt.i18r_fst > 0) { // 前回の団体が指定されている場合
//hf.l(`icvI1zS11Co2 112: here`);
              icm.udtI1zzFromI18rz({
                i1zz: $i1zz,
                i18rz: $i18rz,
              });
              icm.udtI1z3z({
                i1zz: $i1zz,
                i17rs: [],
              });
              _frcUdt();
            }
          }
        }),
      ],
    })
  }, [
    pz.sPz.crt.i1zr_fst,
  ])

  const _dffz = icm.grtDffz({
    mode: pz.sPz.crt.ctt,
  });

//hf.l(`icvI1zS11Co2 135: ${pz.cz.i18r_fst}`);
//hf.l(`icvI1zS11Co2 135: ${pz.sPz.crt.i18r_fst}`);
//hf.l(`icvI1zS11Co 143: ${_gStgz.crt.alyMthSttDate}, ${_gUserz.crt.i19rz?.i19ra4100i}, ${pz.sPz.crt.ctt}`)
  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a('mb/2'),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -10,
              abtType: 'cttCmnz',
              oClds: [

                cr.c(icvI1zS11Co2a.N, { // 仮押中の部屋・日時
                  key: -25,
                  sPz: pz.sPz,
                  cz: {
                    i1zz: $i1zz,
                  }
                }),

                cr.c(LblC.N, {
                  key: -30,
                  abtType: 'ctdBrdStfz',
                  boxStlz: a('dw/80 mb/5 pt/2'),
                  cttCz: {
                    oClds: [
                      cr.c(GridC.N, {
                        key: -10,
                        abtType: 'nolineCmnz',
                        lineCs: [
                          {
                            cellCs: [
                              {
                                oClds: [
                                  cr.c(LblC.N, {
                                    key: -10,
                                    abtType: 'hzlStfz',
                                    boxStlz: a(`mb/1`),
                                    lblCz: {
                                      boxStlz: a('dw/10 f/n fd/rcc pr/1'),
                                      textz: {
                                        pfx: '団体',
                                        stlz: a('tc/lt1'),
                                      }
                                    },
                                    cttCz: {
                                      boxStlz: a('fd/rsc'),
                                      oClds: [
                                        cr.c(IptC.S, {
                                          key: -10,
                                          cz: {
                                            bEdit: true,
                                            iptType: 'sch',
                                            ls: $i18rs,
                                            vle: $i1zz.i1zrz?.i1zri18r1f,
                                            onChg: async ( _dz: _ht.dz ) => {
//                                              pz.cz.i18r_fst = _dz.key;
                                              $i1zz.i1zrz.i1zri18r1f = _dz.key
                                              await _loadI18rDzAsync(_dz.key);
                                              icm.udtI1zzFromI18rz({
                                                i1zz: $i1zz,
                                                i18rz: $i18rz,
                                              });
                                              icm.udtI1z3z({
                                                i1zz: $i1zz,
                                                i17rs: [],
                                              })
//hf.l(`icvI1zS11Co2 213: ${_dz.key}`);
//                                              _frcUdt();
                                              pz.sPz.set({
                                                i18r_fst: _dz.key
                                              });
                                            }
                                          }
                                        }),
                                        _hm.f($i15rz.i15ra4100s) ?
                                        cr.c(TextC.N, {
                                          key: -20,
                                          abtType: 'altCmnz',
                                          boxStlz: a('ml/1'),
                                          textz: {
                                            pfx: $i15rz.i15ra4100s,
                                            stlz: a('ts/l')
                                          }
                                        })
                                        : null
                                      ],
                                    }
                                  }),
                                ]
                              },
                            ]
                          },
                        ]
                      }),
                      cr.c(GridC.N, {
                        key: -20,
                        abtType: 'nolineCmnz',
                        boxStlz: a('dw/60'),
                        lineCs: [
                          {
                            boxStlz: a(`mb/1`),
                            cellCs: [
                              {
                                oClds: [
                                  cr.c(LblC.N, {
                                    key: -10,
                                    abtType: 'hzlStfz',
                                    lblCz: {
                                      boxStlz: a('dw/10 f/n'),
                                      textz: {
                                        pfx: 'メール',
                                        stlz: a('tc/lt1')
                                      }
                                    },
                                    cttCz: {
                                      oClds: [
                                        cr.c(TextC.N, {
                                          key: -10,
                                          textz: {
                                            pfx: _hm.f($i18rz?.i18ra4110s) ? $i18rz.i18ra4110s : '−',
                                            stlz: a('tc/lt1')
                                          }
                                        })
                                      ],
                                    }
                                  }),
                                ]
                              },
                            ]
                          },
                          {
                            boxStlz: a(`mb/1`),
                            cellCs: [
                              {
                                oClds: [
                                  cr.c(LblC.N, {
                                    key: -10,
                                    abtType: 'hzlStfz',
                                    lblCz: {
                                      boxStlz: a('dw/10 f/n'),
                                      textz: {
                                        pfx: '利用制限',
                                        stlz: a('tc/lt1')
                                      }
                                    },
                                    cttCz: {
                                      oClds: [
                                        cr.c(TextC.N, {
                                          key: -10,
                                          textz: {
                                            pfx: ihd.r(ihd.f('i18rt1100i').ls, $i18rz?.i18rt1100i) ?? '−',
                                            stlz: a('tc/lt1')
                                          }
                                        })
                                      ],
                                    }
                                  }),
                                ]
                              },
                            ]
                          },
                          {
                            boxStlz: a(`mb/1`),
                            cellCs: [
                              {
                                oClds: [
                                  cr.c(LblC.N, {
                                    key: -10,
                                    abtType: 'hzlStfz',
                                    lblCz: {
                                      boxStlz: a('dw/10 f/n'),
                                      textz: {
                                        pfx: '備考',
                                        stlz: a('tc/lt1')
                                      }
                                    },
                                    cttCz: {
                                      oClds: [
                                        cr.c(TextC.N, {
                                          key: -10,
                                          textz: {
                                            pfx: $i18rz?.i18ra6200s ?? `−`,
                                            stlz: a('tc/lt1')
                                          }
                                        })
                                      ],
                                    }
                                  }),
                                ]
                              },
                            ]
                          },

                        ]
                      }),
                    ]
                  }
                }),

                cr.c(LblC.N, {
                  key: -40,
//                  abtType: 'subStfz',
                  abtType: 'barHdrStfz',
                  boxStlz: a('ph/2'),
                  lblCz: {
                    boxStlz: a(`mb/3`),
                    textz: {
//                      pfx: 'この団体のエントリー・予約・支払状況（直近30件）',
                      pfx: 'この団体のエントリー・予約状況（直近30件）',
                      stlz: a('ts/l tc/gn7'),
                    }
                  },
                  cttCz: {
                    oClds: [

                      cr.c(icvI1z___TzCnt.N, {
                        key: -10,
                        sPz: pz.sPz,
                        boxStlz: a(`mb/2`),
                        cz: {
                          ctt: pz.sPz.crt.ctt,
                          i18r_fst: $i1zz.i1zrz.i1zri18r1f,
                          sc: 'gn7',
                          tc: 'lt1',
                          tgtSttDate:
                            _gUserz.crt.i19rz?.i19ra4100i == 3 && pz.sPz.crt.ctt == 'e'?
                              _gStgz.crt.alyMthSttDate
                            : undefined,
                        }
                      }),

                      cr.c(icvI1zS11Co2b.N, {
                        key: -20,
                        sPz: pz.sPz,
                        cz: {
                          i18r_fst: $i1zz.i1zrz.i1zri18r1f
                        }
                      }),

                    ]
                  }
                }),
              ],
            }),

            cr.c(GridC.N, {
              key: -40,
              abtType: 'barBtnViewCmnz',
              lineCs: [
                {
                  cellCs: [ // 予約・エントリー状況の更新に影響があるため、部屋・日時の選択画面に戻るを不可とする
/*
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -10,
                          abtType: 'backCmnz',
                          lblCz: {
                            textz: {
                              pfx: '部屋・日時の選択画面に戻る',
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                steps: [1],
                                phs: 'udt', // udtAsync に対応するため crt でなく　udt
                              });
                            }
                          },
                        }),
                      ]
                    },
*/
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -10,
                          abtType: 'nextCmnz',
                          lblCz: {
                            textz: {
                              pfx: `${_dffz.tgt}内容の登録へ`,
                            },
                          },
                          pslPtyz: {
                            onPress: async () => {
                              icm.saveI1zzAddAsync1({
                                role: 's',
                                ctt: pz.sPz.crt.ctt,
                                _31r_fst: _gUserz.crt._31rz._fst,
                                i1zz: $i1zz,
                                i10rs: pz.pagez.i10rs,
                                i17rs: pz.pagez.i17rs,
                                i15rs: pz.pagez.i15rs,
                                i18rz: $i18rz,
                                hdys: pz.pagez.hdys,
                                chkStep: 2,
                                sMsgz: _sMsgz,
                                sLdrz: _sLdrz,
                                sCfmz: _sCfmz,
                                atrAsync: (_dz: _ht.dz) => {
                                  pz.sPz.set({
                                    steps: [3],
                                    phs: 'crt',
                                    i1zr_fst: _dz.i1zrz._fst,
                                  });
                                }
                              })
                            }
                          },
                        }),

                      ]
                    },
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -240,
                          abtType: 'backCmnz',
/*
                          boxStlz: 
                            pz.sPz.crt.ctt == 'e' ?
                              a('dw/29')
                            : a('dw/22'),
*/
                          lblCz: {
                            textz: {
                              pfx: `この${pz.sPz.crt.dffz.tgt}を削除`,
                            },
                          },
                          pslPtyz: {
                            onPress: async () => {
                              icm.saveI1zzDltAsync1({
                                i1zz: $i1zz,
                                i10rs: pz.pagez.i10rs,
                                i17rs: pz.pagez.i17rs,
                                i15rs: pz.pagez.i15rs,
                                i18rz: $i18rz,
                                hdys: pz.pagez.hdys,
                                ctt: pz.sPz.crt.ctt,
                                sCfmz: _sCfmz,
                                sLdrz: _sLdrz,
                                atrAsync: () => {
                                  pz.sPz.set({
                                    steps: [0],
//                                    bBack: true,
                                  })
                                }
                              })

                            }
                          },
                        }),
                      ]
                    }
                  ]
                }
              ]
            })
          ]
        })

      ]
    })
  );
};
